// ------------------------------------------------------------------------------
// 初期設定 - 運用状態予告メッセージ
// ------------------------------------------------------------------------------
import {SnackMessage, snackOperations} from '../reducks/snackbar';

/**
 * まもなく業務開始メッセージ
 *
 * @return {SnackMessage} 業務開始予告メッセージ
 */
const comingOpen = () => new SnackMessage(
    'TKSCS00135I', [], null,
    5 * 60 * 1000, SnackMessage.LOW);

/**
 * まもなく業務終了メッセージ
 *
 * @return {SnackMessage} 業務終了予告メッセージ
 */
const comingClose = () => new SnackMessage(
    'TKSCS00136I', [], null,
    5 * 60 * 1000, SnackMessage.LOW);

/**
 * 運用状態予告メッセージ取得
 *
 * - 引数で指定した運用状態予定に対するメッセージを取得
 *
 * @param {string} comingSoon 運用状態予定
 * @return {SnackMessage|null} 運用状態予告メッセージ
 */
export function comingMessage(comingSoon) {
  switch (comingSoon) {
    case 'open': return comingOpen();
    case 'close': return comingClose();
    default: return null;
  }
}

/**
 * 運用状態予告メッセージ消去
 *
 * @param {Function} dispatch ディスパッチ関数
 */
export function clearComing(dispatch) {
  dispatch(snackOperations.deleteMessage(comingOpen()));
  dispatch(snackOperations.deleteMessage(comingClose()));
}

// ------------------------------------------------------------------------------
// エクスポート
// ------------------------------------------------------------------------------
export default {
  comingMessage,
  clearComing,
};
